module.exports = __webpack_public_path__ + "img/安疗系统2.cc69fd40.png";